import * as types from './action-types';

export function setSelectedMenu(menu) {
  return {
    type: types.SET_SELECTED_MENU,
    payload: menu,
  }
}

export function setSelectedCell(cell) {
  return {
    type: types.SET_SELECTED_CELL,
    payload: cell,
  }
}

export function setVisibleMenus(menus) {
  return {
    type: types.SET_VISIBLE_MENUS,
    payload: menus,
  }
}

export function setColorMode(mode) {
  return {
    type: types.SET_COLOR_MODE,
    payload: mode,
  }
}

export function setGenerationsLocked(locked) {
  return {
    type: types.SET_GENERATIONS_LOCKED,
    payload: locked,
  }
}


// WEBPACK FOOTER //
// ./src/core/ui/actions.js